<template>
    <div id="video-accounting">
        <div class="main-container custom—scrollbar">
            <div class="select-container">
                <el-select v-model="currentArea.areaCode" @change="getAreaTypeResourceStaticsDataListFunc" placeholder="请选择">
                    <el-option
                        v-for="(areaItem, index) in areaList"
                        :key="index"
                        :label="areaItem.areaName"
                        :value="areaItem.areaCode">
                    </el-option>
                </el-select>
            </div>
            <div>
                <el-radio-group @change="schoolTypeChange" v-model="schoolType" size="small">
                    <el-radio-button v-for="(periodItem, index) in schoolPeriodList" :key="index" :label="periodItem.code">
                        {{periodItem.value}}
                    </el-radio-button>
                </el-radio-group>
            </div>
            <div class="section accounting-by-school">
                <el-table
                    :data="accountingData"
                    border
                    style="width: 100%"
                >
                    <el-table-column
                        label="资源名称"
                        show-overflow-tooltip
                        :resizable="false"
                    >
                        <template slot-scope="scope">
                            <router-link :to="{path: 'videoSchoolAccounting', query: {resourceId: scope.row.id, resourceName: scope.row.resourseName, schoolType, sendType: scope.row.sendType}}">
                                <span class="link">{{scope.row.resourseName}}</span>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="观看次数"
                        align="center"
                        width="250px"
                        :resizable="false"
                        prop="visitorCount"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="praiseCount"
                        label="点赞次数"
                        align="center"
                        width="250px"
                        :resizable="false"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="commentCount"
                        label="评论条数"
                        align="center"
                        width="250px"
                        :resizable="false"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="fluxCount"
                        label="流量总计(Gb)"
                        align="center"
                        width="250px"
                        :resizable="false"
                    >
                    </el-table-column>
                </el-table>
                <div class="pagination-container">
                    <el-pagination
                        @size-change="sizeChangeHandler"
                        @current-change="currentChangeHandler"
                        :current-page.sync="pagination.pageNo"
                        :page-sizes="[10 , 20, 30, 50]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-count="pagination.pages"
                        :total="pagination.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { findDicsByCode } from '@/api/common/common';
    import { getAreaTypeResourceStaticsDataList, getUserStaticAreaCodeList } from '@/api/accounting/accounting';
    import baseMixin from '@/mixins/baseMixin.js';

    export default {
        name: "videoAccounting",
        mixins: [baseMixin],
        data() {
            return {
                accountingData: [],
                schoolPeriodList: [],
                schoolType: null,
                currentArea: {
                    areaCode: 0
                },
                areaList: []
            }
        },
        created() {
            getUserStaticAreaCodeList()
                .then(res => res.data)
                .then(data => {
                    this.currentArea.areaCode = data.data[0].areaCode;
                    this.areaList = data.data;
                    findDicsByCode({
                        dicCode: 'schoolPeriodType'
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.data.length > 0) {
                                this.schoolPeriodList = data.data.filter(item => item.code !== '0');
                                this.schoolType = data.data[0].code;
                                this.getAreaTypeResourceStaticsDataListFunc();
                            }
                        });
                })
        },
        methods: {
            schoolTypeChange(schoolType) {
                this.schoolType = schoolType;
                this.getAreaTypeResourceStaticsDataListFunc();
            },
            getAreaTypeResourceStaticsDataListFunc() {
                getAreaTypeResourceStaticsDataList({
                    pageSize: this.pagination.pageSize,
                    pageNo: this.pagination.pageNo,
                    searchType: this.schoolType,
                    areaCode: this.currentArea.areaCode
                })
                    .then(res => res.data)
                    .then(data => {
                        this.accountingData = data.data.dataList;
                        this.pagination.total = data.data.pagination.total;
                        this.pagination.pages = data.data.pagination.pages;
                    })
            },
            sizeChangeHandler(pageSize) {
                this.pagination.pageSize = pageSize;
                this.pagination.pageNo = 1;
                this.getAreaTypeResourceStaticsDataListFunc();
            },
            currentChangeHandler(pageNo) {
                this.pagination.pageNo = pageNo;
                this.getAreaTypeResourceStaticsDataListFunc();
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    @include reset-global;

    .main-container {
        width: 1320px;
        padding: 30px;
        min-height: 560px;
    }
    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .section {
        margin: 20px 0;
    }
    .pagination-container {
        text-align: right;
    }
    .select-container {
        margin-bottom: 10px;
    }
</style>
<style lang="scss" >
    #video-accounting a {
        color: #20a0ff !important;
        text-decoration: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/accounting/videoAccounting.vue